import { Component } from '@angular/core';
import { LucideAngularModule, ArrowDown } from 'lucide-angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-model',
  standalone: true,
  imports: [LucideAngularModule, TranslateModule],
  template: `
    <section id="model" class="py-20 md:py-28 bg-dark-200 relative overflow-hidden">
      <div class="max-w-7xl mx-auto px-5 md:px-10">

        <div class="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          <!-- Left: Copy -->
          <div data-aos="fade-right">
            <p class="text-primary font-bold text-xs tracking-[0.2em] uppercase mb-3">{{ 'MODEL.LABEL' | translate }}</p>
            <h2 class="text-3xl md:text-[2.75rem] font-black mb-5 leading-[1.1]">
              {{ 'MODEL.TITLE_1' | translate }}<br/>{{ 'MODEL.TITLE_2' | translate }}
            </h2>
            <p class="text-base text-gray-450 leading-relaxed mb-6">
              {{ 'MODEL.DESC_1' | translate }}
            </p>
            <p class="text-base text-gray-350 leading-relaxed">
              {{ 'MODEL.DESC_2' | translate }} <span class="text-white font-bold">{{ 'MODEL.DESC_3' | translate }}</span>
            </p>
          </div>

          <!-- Right: Visual workflow -->
          <div class="space-y-3">
            <div class="bg-dark-300 border border-white/[0.06] rounded-xl p-5 flex items-center gap-4" data-aos="fade-up" data-aos-delay="100">
              <div class="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary font-black text-sm flex-shrink-0">01</div>
              <div>
                <p class="text-white font-bold text-sm">{{ 'MODEL.STEP_1_TITLE' | translate }}</p>
                <p class="text-gray-550 text-xs">{{ 'MODEL.STEP_1_DESC' | translate }}</p>
              </div>
            </div>

            <div class="flex justify-center py-0.5" data-aos="fade-up" data-aos-delay="150">
              <lucide-icon [img]="ArrowDown" class="w-4 h-4 text-gray-750"></lucide-icon>
            </div>

            <div class="bg-dark-300 border border-white/[0.06] rounded-xl p-5 flex items-center gap-4" data-aos="fade-up" data-aos-delay="200">
              <div class="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary font-black text-sm flex-shrink-0">02</div>
              <div>
                <p class="text-white font-bold text-sm">{{ 'MODEL.STEP_2_TITLE' | translate }}</p>
                <p class="text-gray-550 text-xs">{{ 'MODEL.STEP_2_DESC' | translate }}</p>
              </div>
            </div>

            <div class="flex justify-center py-0.5" data-aos="fade-up" data-aos-delay="250">
              <lucide-icon [img]="ArrowDown" class="w-4 h-4 text-gray-750"></lucide-icon>
            </div>

            <div class="bg-dark-300 border border-white/[0.06] rounded-xl p-5 flex items-center gap-4" data-aos="fade-up" data-aos-delay="300">
              <div class="w-10 h-10 rounded-lg bg-accent-green/10 flex items-center justify-center text-accent-green font-black text-sm flex-shrink-0">03</div>
              <div>
                <p class="text-white font-bold text-sm">{{ 'MODEL.STEP_3_TITLE' | translate }}</p>
                <p class="text-gray-550 text-xs">{{ 'MODEL.STEP_3_DESC' | translate }}</p>
              </div>
            </div>

            <div class="flex justify-center py-0.5" data-aos="fade-up" data-aos-delay="350">
              <lucide-icon [img]="ArrowDown" class="w-4 h-4 text-gray-750"></lucide-icon>
            </div>

            <div class="bg-dark-300 border border-primary/20 rounded-xl p-5 flex items-center gap-4" data-aos="fade-up" data-aos-delay="400">
              <div class="w-10 h-10 rounded-lg bg-primary flex items-center justify-center text-white font-black text-sm flex-shrink-0">04</div>
              <div>
                <p class="text-white font-bold text-sm">{{ 'MODEL.STEP_4_TITLE' | translate }}</p>
                <p class="text-gray-550 text-xs">{{ 'MODEL.STEP_4_DESC' | translate }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  `
})
export class ModelComponent {
  readonly ArrowDown = ArrowDown;
}
